/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import moment from 'moment';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export const countTypes = [
  {
    value: 'all',
    label: 'All Students',
  },
  {
    value: 'youngest',
    label: 'Youngest in Family',
  },
  {
    value: 'eldest',
    label: 'Eldest in Family',
  },
];

export default class BasicClassCountsController extends Controller {
  date = moment().format('YYYY-MM-DD');
  queryParams = ['countType'];
  countTypes = countTypes;

  @tracked
  countType;

  @computed('selectedCountType')
  get title() {
    return `Basic Class Counts (${this.selectedCountType.label})`;
  }

  @computed('countType')
  get selectedCountType() {
    return findBy(this.countTypes, 'value', this.countType);
  }

  @computed('model.genderField.options.[]')
  get genderOptions() {
    let fieldOptions = this.get('model.genderField.options') || [];
    return fieldOptions.reduce(
      (options, option) => {
        if (['M', 'F'].includes(option.value)) {
          // Skip M/F - custom labels in initial value (below).
          return options;
        }
        options.push({ value: option.value, label: option.label });
        return options;
      },
      [
        { value: 'M', label: 'Boys' },
        { value: 'F', label: 'Girls' },
      ],
    );
  }

  @computed(
    'model.homerooms.[]',
    'genderOptions.[]',
    'countType',
    'sortProp',
    'sortDir',
  )
  get homeroomCounts() {
    let genderCounts = this.genderOptions.reduce((counts, gender) => {
      counts[gender.value] = 0;
      return counts;
    }, {});
    return this.model.homerooms.map((homeroom) => {
      return homeroom.currentLearners.reduce(
        (acc, learner) => {
          let learnerModel = learner.person.learner;

          if (
            learner.person.enrolmentStatus !== EnrolmentStatus.CURRENT ||
            (this.countType === 'eldest' && !learnerModel.isEldest) ||
            (this.countType === 'youngest' && !learnerModel.isYoungest)
          ) {
            return acc;
          }

          acc.total++;
          acc[learner.person.gender]++;

          return acc;
        },
        Object.assign({ name: homeroom.name, total: 0 }, genderCounts),
      );
    });
  }

  @computed('homeroomCounts.[]', 'genderOptions.[]')
  get totals() {
    return this.homeroomCounts.reduce(
      (acc, homeroom) => {
        acc.total += homeroom.total;
        this.genderOptions.forEach((gender) => {
          acc[gender.value] += homeroom[gender.value];
        });

        return acc;
      },
      this.genderOptions.reduce(
        (counts, gender) => {
          counts[gender.value] = 0;
          return counts;
        },
        { total: 0 },
      ),
    );
  }

  @action
  setSelectedCountType(selected) {
    this.countType = selected.value;
  }
}
